export function formatTimeRange(startTime, endTime) {
    const startMatch = startTime?.match(/\d{2}:\d{2}/);
    const endMatch = endTime?.match(/\d{2}:\d{2}/);

    if (!startMatch || !endMatch) {
        return {
            start: "—",
            end: "—",
            duration: 0,
        };
    }

    const [sh, sm] = startMatch[0].split(":").map(Number);
    const [eh, em] = endMatch[0].split(":").map(Number);

    let duration = (eh * 60 + em) - (sh * 60 + sm);
    if (duration < 0) duration += 24 * 60; // Handle overnight shifts

    return {
        start: startMatch[0],
        end: endMatch[0],
        duration: duration / 60,
    };
}
